import { BrowserRouter as Router, Route } from "react-router-dom";
import { Home } from "./components/home";
import { Room } from "./components/room";

import './ styles/app.css'

function App() {
  return (
    <Router>
      <h1 className="title">chatgram</h1>
      <Route exact path="/">
        <Home />
      </Route>
      <Route path="/room">
        <Room/>
      </Route>
    </Router>
  );
}

export default App;
